export default __webpack_public_path__ + "static/media/80s_bg_right.e40855b3.jpg";